import React, { useState } from "react";
import axios from "axios";
import CustomAlert from "../CustomAlert/CustomAlert";
import "./ContactPageForm.css";

const ContactPageForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    type: "",
    message: "",
    date: new Date().toISOString().split("T")[0],
  });

  // State for managing the custom alert
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: 'success',
    title: '',
    message: '',
    icon: null
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Function to show custom alert
  const showAlert = (variant, title, message, icon = null) => {
    setAlertConfig({
      show: true,
      variant,
      title,
      message,
      icon
    });
  };

  // Function to hide custom alert
  const hideAlert = () => {
    setAlertConfig({
      ...alertConfig,
      show: false
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      // Uncomment this section when you want to use the actual API
      /*
      const response = await axios.post(
        "https://api.dremerz.net/api/Project_17_ManPowerWebsite_feedback_Aplication_Form",
        formData
      );
      */
      
      // Show success alert
      showAlert(
        'success',
        'Message Sent Successfully!',
        'Thank you for contacting us. We will get back to you soon.',
        '✅'
      );
      
      // Reset form data
      setFormData({
        name: "",
        mobile: "",
        email: "",
        type: "",
        message: "",
        date: new Date().toISOString().split("T")[0],
      });
      
    } catch (error) {
      console.error("Error sending message:", error);
      
      // Show error alert
      showAlert(
        'danger',
        'Failed to Send Message',
        'Something went wrong. Please try again or contact us directly.',
        '❌'
      );
    }
  };

  return (
    <>
      <div className="container ContactPageForm-container py-5">
        <div className="row align-items-center">
          {/* Left Side - Contact Information */}
          <div className="col-md-6 mb-4">
            <button className="ContactPageForm-contactBtn">
              Contact Us <span className="arrow">→</span>
            </button>
            <h2 className="ContactPageForm-title">Don't Hesitate Speak</h2>
            <p className="ContactPageForm-description"></p>

            <div className="row">
              <div className="col-12">
                <div className="ContactPageForm-infoBox">
                  <i className="fa fa-phone"></i>
                  <h5>9:00 AM to 6:00 PM</h5>
                  <p>
                    <a
                      href="tel:+919840562357"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      +91-44-40401066
                    </a>
                  </p>
                  <p>24 Hours / 7 Days</p>
                </div>
              </div>
              <div className="col-12">
                <div className="ContactPageForm-infoBox">
                  <i className="fa fa-envelope"></i>
                  <h5>Email Us</h5>
                  <p>infochennai@apollohospitals.com</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Feedback Form */}
          <div className="col-md-6 mb-2">
            <div className="ContactPageForm-formBox">
              <h3 className="ContactPageForm-formTitle">Get in Touch</h3>
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Your Name*"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Mobile Number*"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-12 mb-3">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email Address*"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <textarea
                      className="form-control"
                      placeholder="Additional Message"
                      rows="3"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                  <div className="col-12">
                    <button className="ContactPageForm-submitBtn" type="submit">
                      SEND MESSAGE <i className="fa fa-paper-plane"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Alert Component */}
      <CustomAlert
        show={alertConfig.show}
        onClose={hideAlert}
        variant={alertConfig.variant}
        title={alertConfig.title}
        message={alertConfig.message}
        icon={alertConfig.icon}
        position="center"
        overlay={true}
        dismissible={true}
        autoClose={true}
        autoCloseDelay={4000}
        animation="bounce"
        size="normal"
      />
    </>
  );
};

export default ContactPageForm;